import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TechnicalTranslatePipe, FormatRiskAssessmentPipe } from 'app/BaseFramework/shared/custom-pipes';
import {
    ValidationUtilService,
    ApiRequestService,
    LookupDataService,
    CommonUtilty,
    I18nService,
    MultiLingualService,
    InteractService,
    ComponentOutputDO,
    AppMetadataHandler,
    CountryCityService
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { environment } from 'environments/environment';
import { PolicyService } from '../../../FunctionalModules/PolicyIssuance/policy.service';
import { AppOrganizationSettings } from '../../../BaseFramework/configs/app-organization-settings.config';
import * as html2pdf from 'html2pdf.js';
import { HttpClient} from '@angular/common/http';
import { DataTransformService } from 'app/ViewModules/shared-services';

interface benefitDO {
    id: Number,
    productVersion: any,
    productCd: any,
    benefitCd: any,
    event: any,
    benefitAmt: any,
    approveAmt: any,
    decisionCd: any,
    note: any,
}


@Component({
    selector: 'risk-summarization',
    templateUrl: './risk-summarization.component.html',
    styleUrls: ['./risk-summarization.component.scss'],    
  providers: [DatePipe, TechnicalTranslatePipe,FormatRiskAssessmentPipe]
})
export class RiskSummarizationComponent implements OnInit {
    _currentComponentName = 'RiskSummarizationComponent'
    constructor(private viewContainerRef: ViewContainerRef,
        private validationUtilService: ValidationUtilService,
        private apiRequestService: ApiRequestService,
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private commonUtilty: CommonUtilty,
        private i18nService: I18nService,
        private multiLingualService: MultiLingualService,
        private translateService: TranslateService,
        private lookupDataService: LookupDataService,
        private interactService: InteractService,
        public appMetadataHandler: AppMetadataHandler,
        private appOrganizationSettings: AppOrganizationSettings,
        private policyService: PolicyService,
        private datePipe: DatePipe,  
        private technicalTranslatePipe: TechnicalTranslatePipe,
        private formatRiskAssessmentPipe : FormatRiskAssessmentPipe,
        private http: HttpClient,
        public dataTransformService: DataTransformService) { }

    //Declaraions which might need developer input

    selectorOfThisComponent = 'underwriting-worksheet'
    /**
     *
     *  Ninad: Whenever any developer is creating a new Component,
     * please make sure that you copy all import commands, constructor and
     * Boiler and Component Creation Kickstart CODE 
     *
     * 
     * Component Creation Kickstart CODE 
     */


    //Initializations
    selectedpolicy: any;
    selectPolNum: any;
    private _IO = null;
    private DO = null;
    public proposalIO = null;
    parentEvent$
    ownerClientDO: any;
    insuredList = [];

    emptyBenfitDO: benefitDO = {
        id: null,
        productVersion: null,
        productCd: null,
        benefitCd: null,
        event: null,
        benefitAmt: null,
        approveAmt: null,
        decisionCd: null,
        note: null
    }
    riskSummarizationContent = null;
    riskSummarizationLoader = false;
    riskSummarizationApiError = false;
    //ComponentSpecific Inputs, Outputs 
    @Output() componentOutput = new EventEmitter<any>();
    @Input() transactionState: string;
    @Input()
    set IO(value: any) {
        console.log("io in underwriting worksheet", JSON.stringify(value));
        this._IO = value;
        //this.lifeInsured = value;
        if (this._IO != null) {
            // this.getDOAndSetPolicy();
            // this.proposalIO = this.getDOName(this._IO);
            // console.log("policy IO in underwriting worksheet", JSON.stringify(this.proposalIO));
      this.clientDoList=this.getClientDOlistWithRole(this._IO)
      let listOfPrimaryInsured = this.commonUtilty.extractClientDOFromIOGeneric(value, 'PRIMARYINSURED');
    this.primaryInsured = listOfPrimaryInsured ? listOfPrimaryInsured[0] ? listOfPrimaryInsured[0] : null : null
        }

    };

    getDOName(IO) {
        console.log(IO)
        if (IO)
            return IO['intimationDO'] || IO['claimDO'] || IO['adjudicationDO'] || IO['investigationDO'] || IO['proposalDO'] || IO['caseDO'];
        else
            null
    }


    private getDOAndSetPolicy() {
        // this.DO = this.getPolicyDO(this._IO);
        // this.DO = this._IO["caseDO"];
        // if (this.DO != null) {
        //     let anyPolicy = this.DO.find(item => true)
        //     if (anyPolicy)
        // this.selectPolNum = this._IO["caseDO"]['proposalNum'];
        // this.selectedpolicy = this.findPolicyByNum(this.selectPolNum);
        let ownerClient: any
        this.selectedpolicy = this._IO;
        if (this.selectedpolicy && this.selectedpolicy.proposalDO) {
            if (this.selectedpolicy.proposalDO.proposalClients && this.selectedpolicy.proposalDO.proposalClients.length && this.selectedpolicy.proposalDO.proposalClients.length > 0)
                ownerClient = this.selectedpolicy.proposalDO.proposalClients.find(item => item.roleCd === 'OWNER');
        } else if (this.selectedpolicy && this.selectedpolicy.caseDO)
            if (this.selectedpolicy.caseDO.caseClients && this.selectedpolicy.caseDO.caseClients.length && this.selectedpolicy.caseDO.caseClients.length > 0)
                ownerClient = this.selectedpolicy.caseDO.caseClients.find(item => item.roleCd === 'OWNER')

        if (ownerClient)
            this.ownerClientDO = this.selectedpolicy.clientDOs.find(item => item.guid === ownerClient.clientRefGuid)
        // this.getOwnerName();
        console.log("selected policy data", JSON.stringify(this.selectedpolicy));

        // }
    }

    get IO() {
        return this._IO;
    }


    getPolicyDO(IO) {
        let output = null
        if (IO != null) {
            switch ("policy") {
                case "policy": {
                    if (IO['intimationDO'] || IO['claimDO'] || IO['investigationDO'] || IO['caseDO']) {
                        if (IO['intimationDO'])
                            output = IO['intimationDO']['policies']

                        if (IO['claimDO']) {
                            output = IO['claimDO']['policy']

                        }
                        if (IO['investigationDO'])
                            output = IO['investigationDO']['policy']

                        if (IO['caseDO'])
                            output = IO['caseDO']['policy']

                        break;
                    }
                }
                default: {
                    console.log("Invalid choice");
                    break;
                }
            }
        }

        return output
    }



    EmitComponentOutput(data) {
        let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
    }
    getParentComponent(): Component {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
        } catch { }
    }
    getParentComponentName(): string {
        try {
            return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
        } catch { }
    }
    getCurrentComponentName(): string {
        return this._currentComponentName
    }

    subscribeToParentEvent() {
        if (this.parentEvent$ != null)
            this.parentEvent$.unsubscribe()
        this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {
            this.EmitComponentOutput(null);
        })
    }
    clientDoList  
    primaryInsured = null
    userDetails
    showRiskSummaryTable : boolean = false;
    organizationMetaData: any;
    overallRisk = null;
    refreshModal: boolean = true
    ngOnInit() {
       
        this.interactService.sendriskSummarizationContentSubject$.subscribe(data =>{
            if(data){
               this.riskSummarizationContent = data;
            }
            this.toggelRefresh()
            this.dataTransformService.riskSummarizationLoader = false;
            this.overallRisk = this.extractString("Overall Risk Assessment" ,this.dataTransformService.riskSummary)
            console.log("overall risk string =",this.overallRisk);
        })
        if(this.dataTransformService.riskSummary){
            this.riskSummarizationContent = this.dataTransformService.riskSummary;
            this.dataTransformService.riskSummarizationLoader = false;
            this.overallRisk = this.extractString("Overall Risk Assessment" ,this.dataTransformService.riskSummary)
            console.log("overall risk string =",this.overallRisk);
        }
        if(this.dataTransformService.riskSummarizationResponse){
            this.riskSummarizationResponse = this.dataTransformService.riskSummarizationResponse;
            this.riskSummarizationLoader = false;
        }
        
        const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
       
        this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();
        this.subscribeToParentEvent();
        // this.getRiskSummarizationDetails();
        // this.getClientsForEveryRole(this.IO)
        // this.initializeCoverages(this.IO)
        // this.initializeInsuredList(this.IO)
        // let otherListNode = configData.OtherListNodeMapper[this.transactionState]
        let DO = this.getDOName(this.IO);
        // this.otherPolicyList = this.IO['caseDO']['othercases'] ? this.IO['caseDO']['othercases'] : this.IO['proposalDO']['otherPolicyList'];
        // this.generateUnderwritingSummary();

        if(this.primaryInsured && this.primaryInsured.name){
            let details = this.dataSet.filter(item=> item.name == this.primaryInsured.name)
            this.userDetails = details && this.commonUtilty.isArrayIterable(details) ? details[0] ? details[0] : this.dataSet[0] : this.dataSet[0]
          }
    }

    toggelRefresh() {
        this.refreshModal = false
        setTimeout(() => {
          this.refreshModal = true
        }, 100);
      }

      extractString(keyword: string, markdownData) {
        // const data = JSON.parse(markdownData);
        // const content = data['content'];
    
        // Regular expression to match the string following the provided keyword
        const regex = new RegExp(`\\*\\*${keyword}\\*\\*\\s*:\\s*(.*?\\b.*?)\\n`, 'g');
        const match = regex.exec(markdownData);
    
        if (match && match.length > 1) {
          const extractedString = match[1];
          console.log(`Extracted string for "${keyword}":`, extractedString);
          return extractedString;
        } else {
          console.log(`String "${keyword}" not found.`);
          return null;
        }
      }


    getClientDOlistWithRole(IO) {
        let output = []
      if (IO) {
        let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
        let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
        if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
          output.push(...PRIMARYINSUREDLIST);
        if (INSUREDLIST && Array.isArray(INSUREDLIST))
          output.push(...INSUREDLIST)
      }
      return output
      }
      dataSet = [
        {
          key    : '1',
          name   : 'John Doe',
          recommendation: "Accept with standard premium rates."
        },
        {
          key    : '2',
          name   : 'Alice Smith',
          recommendation: "Reject as Cancer reported, which significantly increases health risks.",
          
        },
        {
          key    : '3',
          name   : 'Dan Miller',
          recommendation: "Accept with Revised Terms. Monitor tobacco consumption and manage diabetes effectively. Consider follow-up health checks.",
          
        },
        {
          key    : '4',
          name   : 'Liem Kim',
          recommendation: "Accept with Revised Terms. Reduced Sum Assured due to existing policy.",
          
        },
      ]
    riskSummarizationResponse = null;
    getRiskSummarizationDetails(){
        this.riskSummarizationLoader = true;
        // API: https://product-dev-services.metamorphosys.co.in/fwa-health/nbu_risk_summary
        // Request: 
        // {
        //    "product_type":"LIFE_Claims_Dev",
        //    "business_process":"FWARISKANALYSIS",
        //    "module_name":"VisionIntelligence",
        //    "model_id":"mistral",
        //    "input_data":"Case Summary:  Applicant Name: Smith Jones  Age: 56   Occupation: Govt job  Residential Location: Chennai     Hobbies: Reading    Medical History:  Hypertension: No  Family Medical History: No Smoking Status: Non-smoker  Alcohol Consumption: No      Tobacco Consumption: Yes  Recent Health Check-Up Results: normal BMI, healthy cholesterol levels, no signs of diabetes. Financial Information:  Annual Income: Rs 2000000  Existing Debts: No loan   Insurance History: Yes, previous health insurance claims. "
        // }  
        // Sample JSON data (Assuming the JSON data is stored in a variable named jsonData)
        const jsonData = `Your JSON data here`;
        const headers = { 'Content-Type': 'application/json' };
        // Parsing JSON
        const data = this.IO;

        // Helper function to calculate age from date of birth


        // Extracting required information
        const clientDO = data.clientDOs?.[0] || {};
        const personDO = clientDO.personDO || {};

        const applicantName = `${personDO.firstName || ''} ${personDO.middleName || ''} ${personDO.lastName || ''}`.trim();
        const dob = new Date(personDO.dateOfBirth);
        const age = this.calculateAge(dob);
        const occupation = clientDO.occupationCd || "N/A";
        const residentialLocation = clientDO.city || "N/A";
        const hobbies = "Reading"; // Placeholder as hobbies are not in JSON

        // Extracting medical history information
        const questionnaires = data.questionnaires?.[0]?.questionnaireDtls || [];
        const medicalHistory = questionnaires.reduce((acc, q) => {
            acc[q.vocabularyCd] = q.responseDtl || "N/A";
            return acc;
        }, {});

        // Adding additional hardcoded medical history
        medicalHistory["Hypertension"] = "No";
        medicalHistory["Family Medical History"] = "No";
        medicalHistory["Recent Health Check-Up Results"] = "normal BMI, Calculated healthy cholesterol levels, no signs of diabetes";

        // Extracting financial information
        const annualIncome = clientDO.income || "N/A";
        const existingDebts = "No loan"; // Placeholder as debts information is not in JSON
        const insuranceHistory = "Yes, previous health insurance claims."; // Placeholder

        // Preparing the case summary
        const caseSummary = {
                "Applicant Name": applicantName,
                "Age": age,
                "Occupation": occupation,
                "Residential Location": residentialLocation,
                "Hobbies": hobbies,
                "Medical History": medicalHistory,
                "Financial Information": {
                "Annual Income": annualIncome,
                "Existing Debts": existingDebts,
                "Insurance History": insuranceHistory
            }
        };

        console.log("Rish Summarization case summary = ",caseSummary);

        let payload = {
            "product_type":"LIFE_Claims_Dev",
            "business_process":"FWARISKANALYSIS",
            "module_name":"VisionIntelligence",
            "model_id":"'palm2-32k",
            // "input_data":caseSummary
        }
        // let URL = `https://product-fwa.metamorphosys.co.in/fwa-health/nbu_risk_summary`
        // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
        // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports_v1`
        let URL = `https://product-dev-v2-fwa.metamorphosys.co.in/dev-fwa-generic/gen_ai/uw_risk_assessment_with_reports`
          this.http.post(URL, payload, { headers })
            .subscribe(jsonResp => {
                console.log("summarization response = ", jsonResp)
                // this.riskSummarizationContent = jsonResp['content'];
                this.riskSummarizationResponse = jsonResp;
                this.riskSummarizationLoader = false;
            }, err => {
                this.riskSummarizationLoader = false;
                this.riskSummarizationApiError = true;
                // this.msg.error('Server Error - Technical issue occurred, please contact IT Support.', { nzDuration: 4000 })
              });
    }

    getUWRiskSummaryDetails(){
       let payload =
       {
           "product_type": "FWARISKANALYSIS",
           "module_name": "GENAI",
           "business_process": "UW_SUMMARIZER",
           "output_lang": "en_US",
           "workflowCd": "NBUINITIATION",
           "companyCd": "MMS_IND",
           "countryCd": "IND",
           "proposal_io": this.IO
       }
        const headers = { 'Content-Type': 'application/json' };
        let URL = `https://product-fwa.metamorphosys.co.in/gen_ai/health/uw_risk_assessment_with_reports`
        this.http.post(URL, payload, { headers })
          .subscribe(jsonResp => {
              console.log("summarization response = ", jsonResp)
              // this.riskSummarizationContent = jsonResp['content'];
              this.riskSummarizationResponse = jsonResp;
              this.riskSummarizationLoader = false;
          }, err => {
              this.riskSummarizationLoader = false;
              this.riskSummarizationApiError = true;
              // this.msg.error('Server Error - Technical issue occurred, please contact IT Support.', { nzDuration: 4000 })
            });
    }
    calculateAge(dob) {
        const birthDate = new Date(dob);
        const difference = Date.now() - birthDate.getTime();
        const ageDate = new Date(difference);
        return Math.abs(ageDate.getUTCFullYear() - 1970);
    }

    findPolicyByNum(proposalNum) {
        let output = {}
        if (proposalNum) {
            this.selectPolNum = proposalNum;
            this.policyService.getPolicyByPolicyNum(this.selectPolNum).subscribe(resp => {
                this.selectedpolicy = resp;
                // this.getOwnerName();

                console.log("selected policy", JSON.stringify(this.selectedpolicy));
                output = this.selectedpolicy;
            },
                (error) => {
                    throw " Something went wrong";
                }
            );

        }
        else {
            output = this.DO.find(item => true) || []
        }

        console.log("=========================", output);
        return output;

    }

    getDateString(rawDate) {
        let dateString
        if (rawDate != null) {
            dateString = moment(rawDate).format('DD MMM YYYY');
        }
        else {
            dateString = '-'
        }
        return dateString
    }

    listOfinsured: any[] = [];
    listOfPrimaryInsured: any[] = [];
    nomineelist: any[] = [];
    payerList: any[] = [];

    getClientsForEveryRole(IO) {
        this.listOfPrimaryInsured = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'PRIMARYINSURED');
        this.listOfinsured = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'INSURED')
        console.log("insured list", JSON.stringify(this.listOfinsured));
        this.nomineelist = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'NOMINEE')
        this.payerList = this.commonUtilty.extractClientDOFromIOGeneric(IO, 'PAYER')
    }

    benefitList: any[] = []
    otherPolicyList: any[] = [];
    finalDecisionList: any[] = [];
    coveragesDecisionList: any[] = [];
    UICoverageInsuredNodeName = "coverageInsuredListMap"

    private initializeCoverages(IO) {
        if (IO) {
            // this.tempInsuredList = this.getAllInsuredsFromIO(IO);
            let DO = this.commonUtilty.getDO(IO);
            this.coveragesDecisionList = this.commonUtilty.deepCopy(DO['caseCoverages']) || this.commonUtilty.deepCopy(DO['proposalCoverages']) || [];
            this.coveragesDecisionList.forEach(coverage => {
                let coverageInsuredList = coverage['caseCoverageInsureds'] || coverage['proposalCoverageInsureds']
                coverage[this.UICoverageInsuredNodeName] = this.commonUtilty.convertArrayToMap(coverageInsuredList, 'clientId');
            });
        }
    }

    getPolicyOwenerName: any;
    getOwnerName() {
        let proposalNum = null
        if (this.selectedpolicy && this.selectedpolicy['caseDO'] != null && this.selectedpolicy['caseDO'].length > 0)
            proposalNum = this.selectedpolicy['caseDO']['proposalNum'] ? this.selectedpolicy['caseDO']['proposalNum'] : '';
        let filterOutput = null;
        let output = {}
        let ownerRefGuid;
        let name = null;
        if (this.selectedpolicy != null && Object.keys(this.selectedpolicy).length && proposalNum) {
            let clientDO = this.selectedpolicy['clientDOs'];
            if (this.selectedpolicy.caseDO && this.selectedpolicy.caseDO.caseClients != null) {

                ownerRefGuid = this.selectedpolicy.caseDO.caseClients.find(item => {
                    if (item.roleCd == "OWNER") {
                        clientDO.filter(ele => {
                            if (ele['guid'] == item.clientRefGuid) {
                                filterOutput = ele['personDO']['firstName'] + ' ' + ele['personDO']['lastName']
                            }
                        })
                    }
                })

            }

        }


        this.getPolicyOwenerName = filterOutput ? filterOutput : '-';


    }

    initializeInsuredList(IO) {
        if (IO)
            this.insuredList = this.getAllInsuredsFromIO(IO);

        console.log("insured list", JSON.stringify(this.insuredList));
    }

    getAllInsuredsFromIO(IO) {
        let output = []
        if (IO) {
            let PRIMARYINSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'PRIMARYINSURED');
            let INSUREDLIST = this.commonUtilty.extractClientDOListFromIOGeneric(IO, 'INSURED');
            if (PRIMARYINSUREDLIST && Array.isArray(PRIMARYINSUREDLIST))
                output.push(...PRIMARYINSUREDLIST);
            if (INSUREDLIST && Array.isArray(INSUREDLIST))
                output.push(...INSUREDLIST)
        }
        return output
    }

    downloadPDF()  {
    const options = {
      margin: 10,
      filename: "worksheet.pdf",
      image: {type: 'jpeg'},
      html2canvas:{},
      jsPDF:{orientation: 'Portrait'}
    };
    const content: Element= document.getElementById('uwWorksheetSection');
    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  underwritingSummary : string;
  generateUnderwritingSummary(){
    let caseDO = this.IO['caseDO'];
    if(caseDO){
    let req_payload = {
        "product_type": "LIFE_Claims_Dev",
        "business_process": "FWARISKANALYSIS",
        "module_name": "VisionIntelligence",
        "outputLang":"ENGLISH",
        "input_data":{
            "LOB": caseDO['baseProductFamilyCd'],
            "proposalNum": caseDO['proposalNum'],
            "baseProductCd": this.technicalTranslatePipe.transform(caseDO['baseProductCd']),
            "proposalSignedDate": caseDO['proposalSignedDt'] ? this.getDateData(new Date(caseDO['proposalSignedDt'])) : null,
            "proposalReceivedDate": caseDO['proposalReceivedDt'] ? this.getDateData(new Date(caseDO['proposalReceivedDt'])) : null,
            "policyCommencementDt": caseDO['policyCommencementDt'] ? this.getDateData(new Date(caseDO['policyCommencementDt'])) : null,
            "policyExpiryDt": this.getExpiryDate(caseDO['policyCommencementDt'], caseDO['policyExpiryDt'], caseDO['proposalterm']),
            "sumInsured": caseDO['sumInsuredAmt'],
            "finalPremiumAmt": caseDO['finalPremiumAmt'],
            "proposalterm": caseDO['proposalterm'] || 1,
            "policyHolder": this.commonUtilty.getFirstNameFromClient(this.ownerClientDO) || '' + " " + (this.commonUtilty.getLastNameFromClient(this.ownerClientDO) || ''),
            "primaryInsured" : this.fetchClientList('PRIMARYINSURED'),
            "insuredList": this.fetchClientList('INSURED'),
            "nomineeList": this.fetchClientList('NOMINEE'),
            "payerList": this.fetchClientList('PAYER'),
            "otherPolicyList" : this.otherPolicyList,
            "coverageList": this.fetchCoverageData()
        }
    }

    this.multiLingualService.generateSummaryForUnderwriting(req_payload).subscribe(resp => {
        this.underwritingSummary = resp.underWriterSummary;
        
      }, (e) => {
        console.log("error captured  for generating underwriting summary: ", e);
      })
    }
  }

  getDateData(dateValue){
    return this.datePipe.transform(dateValue, 'dd/MM/yyyy');
  }

  getExpiryDate(startDate, expiryDate, term) {
    if (expiryDate) {
      return this.getDateData(new Date(expiryDate))
    } else if (startDate) {
      let diff = term || 1;
      let date = new Date(startDate);
      date.setFullYear(date.getFullYear() + diff);
      return  this.getDateData(date)
    } else {
      return null;
    }
  }

  fetchClientList(roleType){
    let clientList = [];
    let extractedClientData = this.commonUtilty.extractClientDOFromIOGeneric(this.IO, roleType);
    if(this.commonUtilty.isArrayIterable(extractedClientData)){
        extractedClientData.forEach(client =>{
            let tempObj = {
                "name": client.nameWithSalutation || client.name,
                "dateOfBirth": client.dateOfBirth,
                "contactNum": client.preferredMobileNum || client.clientContactDetailsList &&  client.clientContactDetailsList.length > 0 ? client.clientContactDetailsList[0].contactNum : null,
                "address": client.preferredAddress
            }
            clientList.push(tempObj);
        });
    }
    return clientList;
  }

  fetchCoverageData(){
    let covList = [];
    if(this.commonUtilty.isArrayIterable(this.coveragesDecisionList)){
        this.coveragesDecisionList.forEach(cov => {
            let tempObj = {
                "productCd": this.technicalTranslatePipe.transform(cov.productCd),
                "sumInsured": cov.sumInsured,
                "totalPremiumAmt": cov.totalPremiumAmt
            }
            covList.push(tempObj);
        })
    }
    return covList;
  }

}
